export const DefaultSelectMenuElevation = 4;
